const angular = require('angular')

module.exports = angular
  .module('sis-ric-one.directive', [])
  .directive('sisRicOne', () => {
    return {
      scope: false,
      template: require('./ric-one.html'),
    }
  })
  .name
